import { useDispatch, useSelector } from "react-redux";
import HeaderModal from "../../../global/headerModal"
import ModalBase from "../../../global/ModalBase"
import { closeExtraVueloModalAction, obtenerExtrasVueloAction, obtenerExtrasVueloRegresoAction } from "../../../ducks/proveedorAereolineaDuck";
import { AppBar, Box, Grid, Tab, Tabs } from "@material-ui/core";
import { useEffect, useState } from "react";
import { FExtraVueloStyle } from "./styles";
import TablaExtraVuelo from "./TablaExtraVuelo";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    )
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const FExtraVuelo = () => {
    const dispatch = useDispatch();
    const classes = FExtraVueloStyle()
    const [value, setValue] = useState(0)
    const { openModalExtraVuelo, vueloTarget } = useSelector((store) => store.vueloProveedor)
    
    useEffect(() => {
        dispatch(obtenerExtrasVueloAction({vuelo: vueloTarget?.IdVueloProveedor}))

        if(vueloTarget?.EsRedondo) {
            dispatch(obtenerExtrasVueloRegresoAction({vuelo: vueloTarget?.VueloRedondo.IdVueloRedondo}))
        }
    }, [dispatch, vueloTarget])

    // Ajustar el estado si solo hay una tab
    useEffect(() => {
        if (!vueloTarget?.EsRedondo && value === 1) {
            setValue(0);
        }
    }, [vueloTarget, value]);

    const handleClose = () => {
        dispatch(closeExtraVueloModalAction())
    }

    const handleChange = (event, newValue) => {
        if (vueloTarget?.EsRedondo || newValue === 0) {
            setValue(newValue);
        }
    };

    return (
        <div>
            <ModalBase classes={classes} open={openModalExtraVuelo} onClose={handleClose}>
                <HeaderModal
                    handleClose={handleClose}
                    titulo={`Extras vuelo`}
                />
                    <Grid container className={classes.containerSpacing}>
                        <AppBar position="static">
                            <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                                <Tab label="Extras vuelo ida" {...a11yProps(0)} />
                                {vueloTarget?.EsRedondo && <Tab label="Extras vuelo regreso" {...a11yProps(1)} />}
                            </Tabs>
                        </AppBar>
                        <TabPanel value={value} index={0}>
                            <TablaExtraVuelo tipo="ida" />
                        </TabPanel>
                        {vueloTarget?.EsRedondo && (
                            <TabPanel value={value} index={1}>
                                <TablaExtraVuelo tipo="regreso" />
                            </TabPanel>  
                        )}
                    </Grid>
                </ModalBase>
        </div>
    )
}

export default FExtraVuelo